var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.643 22.643"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(0,0,0,0)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.617 16.255a5.638 5.638 0 105.638-5.638 5.638 5.638 0 00-5.638 5.638zM16.255 13.436v5.638M16.255 19.074l2.114-2.114M16.255 19.074l-2.114-2.114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.798 19.075H2.16a1.41 1.41 0 01-1.41-1.41V2.16A1.41 1.41 0 012.16.75h9.988a1.409 1.409 0 011 .412l2.7 2.7a1.41 1.41 0 01.413 1v2.94"
  }))));
}

export default __webpack_public_path__ + "download-af8c1a8ba0d5d18f53a2d4360af186cf.svg";
export { SvgDownload as ReactComponent };